export default __webpack_public_path__ + "static/media/flask_black_bg.296abf7b.svg";